import { Brand } from './brand.component'

export const Header = () => (
  <header>
    <Brand />
    <h2>Touchpoint Apparel</h2>
  </header>
);
